// removed by extract-text-webpack-plugin
module.exports = {"articleTeamHeader":"articles__articleTeamHeader__21JM6","left":"articles__left__2TL09","right":"articles__right__3ksn-","articlesPostData":"articles__articlesPostData__38Z22","articleBody":"articles__articleBody__3rYvr","articleImage":"articles__articleImage__Sway8","articleText":"articles__articleText__3OmlC","videoWrapper":"articles__videoWrapper__sD0_F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Articles/articles.css
// module id = 37
// module chunks = 0